import {Component} from 'react';

export default class Login extends Component {
    componentWillMount() {
        window.location = `${window.SSO_UI_URL}/login?next=${window.location}`;
    }

    render() {
        return null;
    }
}



// WEBPACK FOOTER //
// ./views/login/index.js